<template>
  <avs-button
    classB="min-width-200 font-weight-bold"
    color="primary"
    iconI="mdi-domain"
    :spantext="$t('nav.title.SelectCompany')"
    text
    :to="{ name: 'SelectCompany' }"
  >
    <template v-slot:name> {{ current }}</template>
  </avs-button>
</template>

<script>
export default {
  name: "CompanyButton",
  computed: {
    current() {
      return this.$store.state.app.company?.name || this.$t("commons.not_selected")
    }
  }
}
</script>
